Sage.common = {
  init: function() {
    // JavaScript to be fired on all pages
  },
  finalize: function() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  }
};
